import service from "@irati/utils/tracking/index";
var tracking = {
    homepagePerksSeeAll: function () {
        service.trackEvent("homepage_perks_see_all", {});
    },
    homePageChangeView: function (pageView) {
        var params = {
            pageView: pageView
        };
        service.trackEvent("homepage_change_view", params);
    },
    // layout
    homePageReorderLayout: function () {
        service.trackEvent("homepage_reorder_layout", {});
    },
    homePageSaveLayout: function () {
        service.trackEvent("homepage_save_layout", {});
    },
    homePageCancelSaveLayout: function () {
        service.trackEvent("homepage_cancel_save_layout", {});
    },
    // company news
    homePageCreateRowModal: function () {
        service.trackEvent("homepage_open_create_row_modal", {});
    },
    homePageSelectRowSize: function (rowType) {
        var params = {
            rowType: rowType
        };
        service.trackEvent("homepage_select_row", params);
    },
    homePageRemoveRow: function () {
        service.trackEvent("homepage_remove_modal", {});
    },
    homePageAddNewTileModal: function () {
        service.trackEvent("homepage_add_new_tile_modal", {});
    },
    homePageAddNewTileSubmit: function (type) {
        var params = {
            type: type
        };
        service.trackEvent("homepage_add_new_tile_submit", params);
    },
    homePageAddNewTileChangeTab: function (tab) {
        var params = {
            tab: tab
        };
        service.trackEvent("homepage_add_new_tile_change_tab", params);
    },
    homePageDeleteTileModal: function () {
        service.trackEvent("homepage_open_delete_tile_modal", {});
    },
    homePageDeleteTile: function () {
        service.trackEvent("homepage_delete_tile", {});
    }
};
export default tracking;
